import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isMobileUA } from 'dpl/shared/utils';
import { get } from 'dpl/shared/utils/object';

import QuizDeliveryMethodQuestionMobile from '../components/QuizDeliveryMethodQuestionMobile';
import QuizDeliveryMethodQuestion from '../components/QuizDeliveryMethodQuestion';

const PICKUP_INPUT_NAME = 'can_pickup';
const PICKUP_AT_AIRPORT_INPUT_NAME = 'can_pickup_at_airport';
const MORE_INFO_INPUT_NAME = 'can_discuss_transportation';
const DELIVERY_METHODS_INPUT_NAME =
  'application_delivery_preferences_attributes';

function QuizDeliveryMethodQuestionContainer(props) {
  return isMobileUA() ? (
    <QuizDeliveryMethodQuestionMobile {...props} />
  ) : (
    <QuizDeliveryMethodQuestion {...props} />
  );
}

export default connect(
  (
    _,
    {
      formState,
      availableDeliveryMethods,
      addToFormState,
      pushToFormState,
      removeFromFormState,
      onChange
    }
  ) => {
    const { methods, pickup, pickupAtAirport, deliveryMoreInfo } =
      availableDeliveryMethods;

    function getFormIdxByDeliveryMethod(dmId) {
      const selectedDeliveryMethods =
        formState[DELIVERY_METHODS_INPUT_NAME] || [];
      return selectedDeliveryMethods.findIndex(
        adpa => adpa.delivery_method_id === dmId
      );
    }

    function handleDeliveryMethodClick(e) {
      const selectedDeliveryMethods =
        formState[DELIVERY_METHODS_INPUT_NAME] || [];
      const value = Number(e.target.value);
      const formIdx = getFormIdxByDeliveryMethod(value);

      if (e.target.checked) {
        if (formIdx === -1) {
          pushToFormState(DELIVERY_METHODS_INPUT_NAME, {
            delivery_method_id: value
          });
        } else {
          addToFormState(`${DELIVERY_METHODS_INPUT_NAME}.${formIdx}`, {
            id: selectedDeliveryMethods[formIdx].id,
            delivery_method_id: value
          });
        }
      } else {
        removeFromFormState(`${DELIVERY_METHODS_INPUT_NAME}.${formIdx}`);
      }
    }

    function handleOtherMethodClick(name) {
      return onChange(name, !formState[name]);
    }

    function isDeliveryMethodSelected(id) {
      const formIdx = getFormIdxByDeliveryMethod(id);
      const value = get(
        formState,
        `${DELIVERY_METHODS_INPUT_NAME}.${formIdx}`,
        {}
      );

      return formIdx !== -1 && !value._destroy;
    }

    return {
      availableDeliveryOptions: [
        ...methods.map(method => ({
          inputName: DELIVERY_METHODS_INPUT_NAME,
          title: method.display_name,
          subtitle: method.description,
          value: method.id,
          isSelected: isDeliveryMethodSelected(method.id),
          onSelect: handleDeliveryMethodClick,
          imageSrc: method.photo_url
        })),
        pickup && {
          inputName: PICKUP_INPUT_NAME,
          title: pickup.display_name,
          subtitle: pickup.description,
          value: '',
          isSelected: Boolean(formState[PICKUP_INPUT_NAME]),
          onSelect: () => handleOtherMethodClick(PICKUP_INPUT_NAME),
          imageSrc: pickup.photo_url
        },
        pickupAtAirport && {
          inputName: PICKUP_AT_AIRPORT_INPUT_NAME,
          title: pickupAtAirport.display_name,
          subtitle: pickupAtAirport.description,
          value: '',
          isSelected: Boolean(formState[PICKUP_AT_AIRPORT_INPUT_NAME]),
          onSelect: () => handleOtherMethodClick(PICKUP_AT_AIRPORT_INPUT_NAME),
          imageSrc: pickupAtAirport.photo_url
        },
        deliveryMoreInfo && {
          inputName: MORE_INFO_INPUT_NAME,
          title: deliveryMoreInfo.display_name,
          subtitle: deliveryMoreInfo.description,
          value: '',
          isSelected: Boolean(formState[MORE_INFO_INPUT_NAME]),
          onSelect: () => handleOtherMethodClick(MORE_INFO_INPUT_NAME),
          imageSrc: deliveryMoreInfo.photo_url
        }
      ].filter(Boolean)
    };
  }
)(QuizDeliveryMethodQuestionContainer);

QuizDeliveryMethodQuestionContainer.propTypes = {
  availableDeliveryMethods: PropTypes.shape({
    methods: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string,
        photo_url: PropTypes.string,
        title: PropTypes.string,
        value: PropTypes.string
      })
    ),
    pickup: PropTypes.shape({
      description: PropTypes.string,
      display_name: PropTypes.string,
      name: PropTypes.string,
      photo_url: PropTypes.string
    }),
    pickupAtAirport: PropTypes.shape({
      description: PropTypes.string,
      display_name: PropTypes.string,
      name: PropTypes.string,
      photo_url: PropTypes.string
    }),
    deliveryMoreInfo: PropTypes.shape({
      description: PropTypes.string,
      display_name: PropTypes.string,
      name: PropTypes.string,
      photo_url: PropTypes.string
    })
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  addToFormState: PropTypes.func.isRequired,
  pushToFormState: PropTypes.func.isRequired,
  removeFromFormState: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired
};
